import type { QueryClient, UseQueryResult } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";
import {
  EventDashboardSchema,
  type EventDashboard,
} from "@shared/schemas/event-dashboard.schemas";
import { BaseApiHooksRepository } from "../../base-api-hooks.repository";
import { createDashboardApi } from "./dashboard.api";

export const DASHBOARD_QUERY_KEYS = {
  byEvent: (eventIdPublic: EventIdPublic) =>
    ["dashboard", eventIdPublic] as const,
} as const;

interface GetEventDashboardOptions {
  readonly enabled?: boolean;
}

export class DashboardHooksHttpRepositoryImpl extends BaseApiHooksRepository {
  private readonly api;

  constructor(queryClient: QueryClient, apiClient: AxiosInstance) {
    super(queryClient);
    this.api = createDashboardApi(apiClient);
  }

  createHooks() {
    return {
      useGetEventDashboard: (
        eventIdPublic: EventIdPublic,
        options: GetEventDashboardOptions = {},
      ): UseQueryResult<EventDashboard> => {
        const { enabled = true } = options;

        return this.query({
          key: DASHBOARD_QUERY_KEYS.byEvent(eventIdPublic),
          fn: () => this.api.getEventDashboard(eventIdPublic),
          parse: (response) => EventDashboardSchema.parse(response),
          enabled: enabled && EventIdPublic.unwrap(eventIdPublic).length > 0,
          staleTime: 30 * 1000,
          retry: 1,
        });
      },
    };
  }
}
